module.exports = __webpack_public_path__ + "media/images/email_1-887787fb49c24f7136bacf3f09bd2fa0.jpg";